var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1395,
    height: 471,
    viewBox: "0 0 1395 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 1395,
    height: 471,
    transform: "translate(334 -1074)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 2011,
    height: 420,
    transform: "translate(611.536 -725.355)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0-1440H949.666V-905.81H0Z",
    transform: "translate(0 1439.997)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M1085.817-944.116h45.628v38.086h-45.628Z",
    transform: "translate(-1085.817 944.116)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M1248.852-829.423h83.575v193.706h-83.575Z",
    transform: "translate(-1248.852 829.423)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M1295.482-474.784h54.406v22.766h-54.406Z",
    transform: "translate(-1295.482 474.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M1287.482-590.784h33.632v11.376h-33.632Z",
    transform: "translate(-1287.482 590.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M1390.143-573.451h18.3v15.333h-18.3Z",
    transform: "translate(-1390.143 573.451)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M1262.149-602.784h26.708v7.914h-26.708Z",
    transform: "translate(-1262.149 602.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M1363.477-616.117H1388.7v6.925h-25.226Z",
    transform: "translate(-1363.477 616.117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M1270.149-633.45H1320.1v7.419h-49.954Z",
    transform: "translate(-1270.149 633.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M1342.143-637.45h25.225v2.968h-25.225Z",
    transform: "translate(-1342.143 637.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M1402.143-654.784h14.838v5.441h-14.838Z",
    transform: "translate(-1402.143 654.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "M1354.143-670.784h28.688v4.452h-28.688Z",
    transform: "translate(-1354.143 670.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M1266.149-714.784h10.387v16.322h-10.387Z",
    transform: "translate(-1266.149 714.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M1258.149-725.45h2.473v18.3h-2.473Z",
    transform: "translate(-1258.149 725.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "M1252.816-730.784h3.957v21.269h-3.957Z",
    transform: "translate(-1252.816 730.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M1130.149-841.45h15.844v31.161h-15.844Z",
    transform: "translate(-1130.149 841.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "M1039.483-794.783h15.333v34.129h-15.333Z",
    transform: "translate(-1039.483 794.783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M1055.483-573.451h11.871v43.526h-11.871Z",
    transform: "translate(-1055.483 573.451)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M1064.816-456.118h5.441v23.247h-5.441Z",
    transform: "translate(-1064.816 456.118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M1132.816-770.783h31.161v31.161h-31.161Z",
    transform: "translate(-1132.816 770.783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M1523.476-532.117h27.2v104.859h-27.2Z",
    transform: "translate(-1523.476 532.117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M1472.81-546.784h9.4v35.612h-9.4Z",
    transform: "translate(-1472.81 546.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M1472.81-370.784h16.322v45.01H1472.81Z",
    transform: "translate(-1472.81 370.784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M1614.143-498.784h25.226v43.526h-25.226Z",
    transform: "translate(-1614.143 498.784)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-334 1074)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-607.536 -297.645)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "curve",
    transform: "translate(733.536 -574.644)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 884,
    cy: 770,
    rx: 884,
    ry: 770,
    transform: "translate(0 0.289)",
    fill: "#f7efff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(534.667 302.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(0 -1439.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(402.799 165.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M-87.01-4.614a2.947,2.947,0,0,1-2.775-1.149l-.437-.582-.989-.989V4.506a15.017,15.017,0,0,1-1.978,7.45l-3.521,3.961a7.146,7.146,0,0,1-.954.893l-2.782,2.164a9.984,9.984,0,0,1-2.511,1.425l-3.954,1.538a12.192,12.192,0,0,0-5.726,4.6,7.856,7.856,0,0,1-2.064,2.1l-3.776,2.614a11.333,11.333,0,0,1-3.072,1.5l-3.121.975a13.216,13.216,0,0,1-6.379.375l-1.7-.319a16.858,16.858,0,0,1-5.572-2.116l1.607,4.031,1.449,5.314c.023.085.048.169.076.252l1.442,4.326.141.705a11.125,11.125,0,0,0,1.248,3.333l1.084,1.9.989,2.473.495,1.978,7.138-5.459a28.451,28.451,0,0,1,2.642-1.794l8.521-5.112,9.4-6.43,6.925-4.946,5.935-3.957,2.968-2.473-.921-4.915a32.848,32.848,0,0,1-.562-6.051V1.593a19.313,19.313,0,0,1,.234-3Z",
    transform: "translate(138.322 7.335)",
    fill: "#eab5a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(402.799 183.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36",
    opacity: 0.4,
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M-70.561-8.395a7.139,7.139,0,0,1-.953.893L-74.3-5.338a9.99,9.99,0,0,1-2.511,1.424l-3.954,1.538a12.192,12.192,0,0,0-5.726,4.6,7.856,7.856,0,0,1-2.064,2.1l-3.776,2.614a11.343,11.343,0,0,1-3.073,1.5l-3.121.975a13.215,13.215,0,0,1-6.379.375l-1.7-.319a16.867,16.867,0,0,1-5.572-2.116l1.607,2.547,2.473,9.4,2.473,5.441.483-11.109a1.25,1.25,0,0,1,.131-.506,1.356,1.356,0,0,1,1.214-.75h.206a6.05,6.05,0,0,1,2.707.639l1.281.641a4.928,4.928,0,0,0,.849.33l1.093.312a5.649,5.649,0,0,0,3.775-.239l5.08-2.177,4.946-2.968,8.409-6.43,2.968-5.441,3.462-3.957,2.473-6.43Z",
    transform: "translate(112.173 13.345)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(375.105 106.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M-4.424-16.745l2.6-2.6A12.59,12.59,0,0,1,3.68-22.563l8.138-2.279a12.822,12.822,0,0,1,2.138-.407l11.981-1.24a24.988,24.988,0,0,1,2.56-.132h7.214a22.522,22.522,0,0,1,4.716.5,13.175,13.175,0,0,1,7.528,4.653,5.28,5.28,0,0,1,1.144,2.91l.67,9.041a47.126,47.126,0,0,0,.7,5.323l1.1,5.8a1.811,1.811,0,0,0,2.276,1.4l3.376-.965A1.731,1.731,0,0,1,59.36,3.21l.52,1.733a3.013,3.013,0,0,1-.6,2.827l-.833.972a1.275,1.275,0,0,0,.4,1.97l.916.458a1.534,1.534,0,0,1,.782.93l2.777,9.259L65.3,29.272l1.484,1.484.495-2.473,1.484-6.925,1.484-5.935.763-2.544a4.833,4.833,0,0,1,3.1-3.2l.588-.2h1.8a1.617,1.617,0,0,1,1.144.473l.515.516,1.074,2.507a5.057,5.057,0,0,1,.41,1.995v4.5a4.833,4.833,0,0,1-.065.792l-.89,5.341a3.516,3.516,0,0,1-.09.4l-1.677,5.87a2.9,2.9,0,0,1-.931,1.43l-1.274,1.061a4.621,4.621,0,0,1-2.306,1.026l-.436.062A2.948,2.948,0,0,1,69.2,34.306l-.437-.582-.989-.989v11.84a15.02,15.02,0,0,1-1.978,7.45l-3.521,3.961a7.143,7.143,0,0,1-.953.893l-2.783,2.164a9.988,9.988,0,0,1-2.511,1.424L52.072,62a12.2,12.2,0,0,0-5.726,4.6,7.841,7.841,0,0,1-2.064,2.1l-3.776,2.614a11.322,11.322,0,0,1-3.073,1.5l-3.121.975a13.222,13.222,0,0,1-6.379.375l-1.7-.319a16.878,16.878,0,0,1-5.572-2.116,20.015,20.015,0,0,1-4.234-3.4L9.407,60.927l-3.9-4.5a21.168,21.168,0,0,1-3.868-6.548L.2,45.963A36.476,36.476,0,0,1-.964,42.195l-1.868-7.472a6.025,6.025,0,0,0-.338-.98,22.838,22.838,0,0,1-1.948-8.323L-5.431,17.9-6.42,4.541-6.915-8.814-6.99-9.56a8.909,8.909,0,0,1,2.565-7.185",
    transform: "translate(7.034 26.62)",
    fill: "#eab5a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(344.697 381.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M-218.667,0l-30.222,25.834a7.539,7.539,0,0,1-.942.688l-32.743,20.224a5.62,5.62,0,0,1-.821.418l-6.54,2.694a3.843,3.843,0,0,1-2.888.014l-3.212-1.285a1.842,1.842,0,0,1-.521-.318l-6.965-6.036a3.349,3.349,0,0,0-.47-.341l-2.223-1.333h-2.653a3.04,3.04,0,0,0-1.512.4l-2.76,1.577h-1.526a4.324,4.324,0,0,0-2.6.865l-.825.619-1.484.989-2.107-.3a1.569,1.569,0,0,0-1.732,1.122l-.394,1.378a1.9,1.9,0,0,0,.177,1.462l1.014,1.774a2.809,2.809,0,0,0,1.67,1.31l1.783.509a4.273,4.273,0,0,0,1.178.165h2.862l-3.957,1.978-10.387,4.452-6.43,2.968-8.964,4.034a3.544,3.544,0,0,0-1.493,1.265l-.587.88a4.1,4.1,0,0,0-.662,2.722l.172,1.545a3.462,3.462,0,0,0,1.278,2.321l.043.034a3.658,3.658,0,0,0,2.961.739l6.264-1.174,5.441-1.484.495.989-5.441,2.473a4.077,4.077,0,0,0-1.139,3.554l.239,1.438a3.754,3.754,0,0,0,2.793,3.025l1.569.392,4.452-1.484h1.484l-1.484,2.473-.094.284a6.007,6.007,0,0,0,.6,5.083l.213.341a2.59,2.59,0,0,0,2.2,1.217h3.017l2.968-1.978h1.484L-318.58,92l-.827.827a2.469,2.469,0,0,0-.547,2.662,2.5,2.5,0,0,0,1.337,1.37l1.321.566a4.014,4.014,0,0,0,2.453.229l3.188-.708,13.849-6.43,6.925-2.968,6.43-5.441,4.042-3.234a7.268,7.268,0,0,1,1.987-1.129l1.159-.435a26.989,26.989,0,0,0,3.327-1.512l4.818-2.594,14.839-6.43L-234,59.354l17.316-6.38a28.558,28.558,0,0,0,2.891-1.25l15.286-7.643a24,24,0,0,0,2.156-1.22l8.744-5.565a16.948,16.948,0,0,1,2.275-1.215l10.475-4.609a11.949,11.949,0,0,1,1.448-.529l6.117-1.8a3.24,3.24,0,0,0,2.118-1.97,10.471,10.471,0,0,0,.579-5.03l-.135-1.034a81.168,81.168,0,0,0-3.485-15.174l-8.9,3.462-9.892,1.484L-197.4,8.9l-9.892-2.473-6.925-2.473Z",
    transform: "translate(347.623)",
    fill: "#eab5a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(366.32 76.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M-148.452-156.778l-.48,5.221v9.454l-.014,3.152,2.589-9.511a18.529,18.529,0,0,0,.538-2.825l.17-1.525a3.733,3.733,0,0,1,1.32-2.455,5.039,5.039,0,0,0,1.814-3.872v-2.091l1.978-6.43.495-8.409.442-1a11.9,11.9,0,0,0,.794-7.166l-.247-1.237-2.473-12.86L-144-208.218l-3.607-10.822a10.084,10.084,0,0,0-.919-2l-3.358-5.6a5.01,5.01,0,0,0-1.349-1.474l-3.341-2.43a6.908,6.908,0,0,0-2.827-1.209l-1.944-.354a4.136,4.136,0,0,1-2.892-2.09l-1.153-2.113a5.15,5.15,0,0,0-2.541-2.289l-3.784-1.576a4.151,4.151,0,0,1-.893-.51l-1.831-1.373a8.145,8.145,0,0,0-3.833-1.56l-7.193-.938a14.72,14.72,0,0,1-3.968-1.1l-6.035-2.624a11.607,11.607,0,0,0-7.093-.7l-5.461,1.187a20.655,20.655,0,0,0-4.349,1.467l-3.961,1.848a16.87,16.87,0,0,0-2.6,1.507l-5.621,3.968a18.491,18.491,0,0,0-2.855,2.49l-1.359,1.456a28.7,28.7,0,0,0-6.244,10.5v0A13.833,13.833,0,0,0-236-219.4v2.093a5.225,5.225,0,0,0,.973,3.036l.859,1.2a4.238,4.238,0,0,1,.763,1.994l.262,2.358a5.58,5.58,0,0,1-.133,1.969l-.71,2.84q-.036.145-.06.292l-.374,2.244a7.083,7.083,0,0,0-.1,1.161v4.362l-.424,5.511a4.572,4.572,0,0,0,.221,1.794l2.676,8.028,2.968,6.925.989,2.473.989,4.452,3.473,7.293-1.989-6.3.094-6.777-.884-12.25-.631-15.154-.17-2.242a9.974,9.974,0,0,1,3.56-8.416l1.987-1.655,3.462-2.473,9.282-2.452,8.461-1.326,11.681-.694,7.672.021,4.072.814a7.24,7.24,0,0,1,5.82,7.1l1.424,14.145,1.186,6.233a1.75,1.75,0,0,0,2.2,1.356l1.747-.5,1.884-.541a1.491,1.491,0,0,1,1.85,1.041l.647,2.373a2.542,2.542,0,0,1-.864,2.653l-.194.155a1.685,1.685,0,0,0-.512,1.941l.347.868a.509.509,0,0,0,.633.293,1.013,1.013,0,0,1,1.3.707l.685,2.636,3.989,14.614,1.484,1.484,2.2-10.356,1.757-6.956.863-1.837,1.115-1.131,1.663-.889,2.294-.1.989.495.568.568.916,2.4.495.989v6.43l-.7,3.6-.784,3.326-.794,3.194-.689,2.247-1.679,1.447-1.784,1.026Z",
    transform: "translate(235.999 249.236)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(378.191 195.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M-143.42,0l-13.355,7.419L-182,24.236l-12.86,8.9-1.978-3.957-16.322,13.355-12.365,10.387L-228,57.376l3.957,8.9,1.978,3.957.989,2.968.989.989s-.989,5.935-.989,6.43,1.484,5.441,1.484,5.441l3.957,8.408,1.978,7.914v16.322l3.462,7.419-.495,11.376-3.462,15.333-.989,16.322,2.968,15.333,2.473,7.419-1.484,12.86-.989,13.849.495,14.839-.989,56.386-2.473,17.806,4.452,5.441,3.957-1.978.989,7.914,15.828-1.484,7.419-.495h14.344l11.871-.989,10.882-2.968,22.752-13.849,27.7-19.785,3.957-61.333,3.957-.989,6.43,4.946,4.452,2.473,8.9-9.892,7.914-10.387v-6.925l-3.957-4.946-6.925-5.935-1.484-1.978,2.473-7.914-.989-12.365.989-3.462-1.978-3.957-.989-5.441-.989-4.452,1.978-8.9-1.978-5.935,1.978-3.462-1.484-5.935-1.978-3.957.495-5.441-.495-2.473-3.957-2.473,2.968-.495.989-2.968-1.978-1.978,4.452-3.462,2.968-5.441L-81.1,87.053l1.484-8.9-2.473-6.43-2.968-12.86-3.462-5.441-4.452-9.4L-107.313,27.7l-4.452-4.946-8.9-3.462-4.946,1.484-6.43-2.473Z",
    transform: "translate(227.999)",
    fill: "#0073d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(463.279 226.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g68",
    opacity: 0.3,
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M-84.8-22.861l4.369,9.223a.607.607,0,0,0,.04.072l3.379,5.31a.66.66,0,0,1,.087.207l2.932,12.7a.621.621,0,0,0,.027.09L-72.9,7.509a14.232,14.232,0,0,1,.755,7.448l-.771,4.624a.664.664,0,0,0,.321.683l10.917,6.368a.664.664,0,0,1,.248.892l-2.592,4.753a.673.673,0,0,1-.176.207L-67.946,35.4a.665.665,0,0,0-.062.995l1.155,1.156a.663.663,0,0,1,.161.68l-.733,2.2a.665.665,0,0,1-.522.445l-.841.14a.665.665,0,0,0-.243,1.219l2.225,1.39a.664.664,0,0,1,.3.433l.419,2.1a.687.687,0,0,1,.011.191l-.469,5.156a.665.665,0,0,0,.068.357l1.861,3.723a.647.647,0,0,1,.05.136l1.4,5.606a.666.666,0,0,1-.068.491l-1.7,2.973a.665.665,0,0,0-.053.54l1.826,5.479a.665.665,0,0,1,.018.355l-1.906,8.579a.66.66,0,0,0,0,.288l.957,4.308.972,5.347a.675.675,0,0,0,.059.179l1.821,3.64a.669.669,0,0,1,.045.48l-.885,3.1a.669.669,0,0,0-.024.236l.969,12.117a.664.664,0,0,1-.028.251l-2.333,7.466a.664.664,0,0,0,.1.6l1.236,1.648a.648.648,0,0,0,.1.106l6.822,5.848a.589.589,0,0,1,.087.089l3.772,4.715a.665.665,0,0,1,.146.415v6.468a.664.664,0,0,1-.136.4l-7.762,10.187c-.011.014-.023.028-.035.042l-8.531,9.478a.664.664,0,0,1-.817.137l-3.946-2.192a.7.7,0,0,1-.083-.054l-5.4-4.154a.665.665,0,0,1,.2-1.157l5.973-1.991a.663.663,0,0,0,.384-.333l1.768-3.536a.661.661,0,0,0,.066-.37l-.96-8.638a.641.641,0,0,0-.031-.137l-3.223-9.671a.665.665,0,0,0-.86-.413l-9.083,3.336a.672.672,0,0,1-.131.034l-8.821,1.323a.667.667,0,0,1-.234-.007l-15.265-3.2a.46.46,0,0,1-.062-.016l-11.624-3.637a.661.661,0,0,1-.243-.138l-4.122-3.664a.664.664,0,0,1-.223-.5v-1.9a.665.665,0,0,1,.194-.47l2.084-2.084a.665.665,0,0,0,.194-.47v-.9a.665.665,0,0,0-.232-.5l-3.182-2.727a.647.647,0,0,0-.1-.073l-3.134-1.791a.665.665,0,0,1-.325-.467l-.426-2.555a.653.653,0,0,1,0-.2l.447-3.127a.666.666,0,0,0-.088-.436L-131.8,95.8a.682.682,0,0,1-.079-.2l-.935-4.21a.675.675,0,0,1,0-.275l.373-1.866a.664.664,0,0,1,.569-.529l3.273-.41a.665.665,0,0,1,.393.072l8.078,4.276a.662.662,0,0,0,.311.078h.16a.665.665,0,0,0,.665-.665V88.892a.656.656,0,0,0-.034-.21L-122.419,78.5a.679.679,0,0,1-.034-.21V71.2a.664.664,0,0,1,.133-.4l2.754-3.673a.671.671,0,0,0,.113-.237l.9-3.588a.663.663,0,0,0-.05-.459.664.664,0,0,0-1.032-.2l-2.974,2.6a.666.666,0,0,1-.735.094l-2.429-1.214a.668.668,0,0,1-.234-.2l-2.862-3.817-.021-.03-.816-1.224a.664.664,0,0,1-.092-.53l.871-3.484a.664.664,0,0,0-.014-.371l-.848-2.545a.664.664,0,0,1,.02-.472l1.308-3.051a.666.666,0,0,0,.045-.371l-.446-2.677a.66.66,0,0,1,0-.2l.961-7.211a.66.66,0,0,0-.007-.218l-.916-4.579a.665.665,0,0,1,.088-.482l2.153-3.444a.666.666,0,0,0,.051-.605l-3.332-8.092L-132.3,14.7a.658.658,0,0,1-.05-.218L-133.333-2.7c0-.016,0-.032,0-.048L-134.8-13.949a.676.676,0,0,1,.026-.288l2.59-8.14a11.88,11.88,0,0,1,2.707-4.578l7.356-7.743a.662.662,0,0,1,.4-.2l11.024-1.438a.659.659,0,0,1,.235.011l6.981,1.611a25.684,25.684,0,0,1,10.364,5.046l8.141,6.576a.661.661,0,0,1,.183.232",
    transform: "translate(134.805 36.343)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(480.577 358.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84",
    opacity: 0.4,
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M-92.258-33.549h0A17.752,17.752,0,0,1-108.075-31.6l-12.376-4.42-17.312-10.387-8.9-6.925,13.355,7.419,14.646,8.262a35.346,35.346,0,0,0,9.854,3.753l6.166,1.34Z",
    transform: "translate(146.666 53.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(477.61 315.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g100",
    opacity: 0.4,
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M0-19.29l7.419-5.441,13.849-3.957,12.365-1.978L16.817-26.215Z",
    transform: "translate(0 30.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(515.693 321.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g116",
    opacity: 0.4,
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M0,0,12.86,1.978,18.3,9.4l-.989,5.935L11.871,6.925Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g120",
    transform: "translate(468.212 310.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132",
    opacity: 0.4,
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M-5.871,0-9.333,3.957-6.86,7.914,3.032,5.935,17.376,0Z",
    transform: "translate(9.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g136",
    transform: "translate(505.801 305.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148",
    opacity: 0.4,
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M-37.742,0-60,5.935l11.376.989h11.871l1.978-3.957Z",
    transform: "translate(60)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g152",
    transform: "translate(471.18 299.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g164",
    opacity: 0.4,
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M0,0,12.365.989l7.914,3.957,12.86-.495,16.817-.495L36.107,6.43l-21.763.989L3.957,6.43Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g168",
    transform: "translate(497.887 297.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g180",
    opacity: 0.4,
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g178",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M0,0,3.462,2.968l21.763-.495Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g184",
    transform: "translate(520.145 291.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g196",
    opacity: 0.4,
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g194",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M-25.161,0l-9.892,2.473L-40,5.441h7.419l5.441-1.978Z",
    transform: "translate(40)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g200",
    transform: "translate(502.338 285.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g212",
    opacity: 0.4,
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g210",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M-42.774,0l3.462,2.968L-49.2,4.452-68,1.484Z",
    transform: "translate(68)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    transform: "translate(469.696 269.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g228",
    opacity: 0.4,
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M-17.613,0l-7.419,6.925L-28,16.322l4.452-8.9Z",
    transform: "translate(28)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g232",
    transform: "translate(466.728 265.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g244",
    opacity: 0.4,
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "M-2.516,0-4,9.892-1.527,18.3l-1.484-7.914Z",
    transform: "translate(4)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g248",
    transform: "translate(464.749 263.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g260",
    opacity: 0.4,
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M-1.677,0l-.989,9.892L1.29,21.269-1.677,9.892Z",
    transform: "translate(2.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g264",
    transform: "translate(528.555 384.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M-12.581,0l-1.978,15.333L-20,32.15-5.656,15.828Z",
    transform: "translate(20)",
    fill: "#1b1464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g268",
    transform: "translate(419.245 222.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g280",
    opacity: 0.4,
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g278",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M-6.71,0l5.441,17.312s5.935,13.849,6.43,13.849S-5.226,25.225-5.226,25.225l-5.441-13.849Z",
    transform: "translate(10.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g284",
    transform: "translate(385.611 239.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g296",
    opacity: 0.4,
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g294",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "M-10.9,0l-6.43,19.785,1.484,9.892L-2,34.129-5.957,25.72Z",
    transform: "translate(17.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g300",
    transform: "translate(391.546 321.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g312",
    opacity: 0.4,
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g310",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M-9.226-10.065-14.667,22.58v4.946L-9.226,16.15-2.8-4.624-7.247-16Z",
    transform: "translate(14.667 16)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g316",
    transform: "translate(395.008 364.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g328",
    opacity: 0.4,
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g326",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M-6.71,0l-3.957,13.849,2.473,9.4L-5.226,9.892Z",
    transform: "translate(10.667)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g332",
    transform: "translate(420.234 248.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g344",
    opacity: 0.4,
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M-52.839,0-68.667,12.365-84,31.161V28.822a15.3,15.3,0,0,1,6.632-12.607l1.282-.881,9.892-8.408Z",
    transform: "translate(84)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g348",
    transform: "translate(463.76 301.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M-26-218.065l-15.333,22.258,8.409,21.269,13.849,31.161,3.462,6.925,29.182,21.269,44.516-17.806,9.4-2.968s11.871-9.4,11.871-9.892,19.785-30.172,19.785-30.172l17.312-32.15,1.978-9.892,3.957-5.441-1.978-2.968,8.408-13.355v-12.365l1.484-3.462-3.462-7.914-9.892-2.968-10.387-31.656L96.17-311.548v-1.484l-8.408-8.9L64.515-346.666,57.59-343.7l-4.452,3.462L47.7-341.72l-6.925,11.376L38.3-315.01l3.957,22.258,2.473,15.333-9.4,14.839,4.452,9.4-1.978,5.441-8.9,10.387-5.935,7.419-1.484.495L16.042-232.9,3.677-228.947l-12.86,6.925-9.4,4.452Z",
    transform: "translate(41.333 346.666)",
    fill: "#1b1464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g352",
    transform: "translate(530.039 384.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "M0-206.323,16.322-224.13l14.344-18.3,13.849-16.817,11.871-21.763,4.946-13.355,4.452-13.355,6.43-10.882,15.828-8.408L97.934-328l4.587.931,2.833,2.037,2.094,5.564-.61,4.328h-.495l-.495-6.43-3.957-.989-6.925,1.484L89.526-318.6l-6.43,7.914-5.441,8.409-2.968,6.43-6.43,10.387,7.914-1.484,7.419-1.484,7.914-.495,5.935.495,1.255.152,1.218,1.826-2.968,4.946-2.968-1.484-9.892.495-5.441,1.484-10.387,4.452-5.935,1.978-8.408,15.333-9.892,17.806v1.978L32.645-229.57,22.258-218.689l-10.882,7.914-7.914,4.452Z",
    transform: "translate(0 327.999)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g356",
    transform: "translate(505.803 405.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M0-171.1l2.473,2.968H7.914l9.4-14.839,7.914-17.806,3.462-11.871,2.473-12.86L37.1-242.322l3.462-12.365L38.58-268.042,37.1-272l-2.968,1.484.989,2.968L32.15-253.2l-3.462,15.828-6.925,22.752-7.914,22.752L6.43-177.033l-3.462,4.452Z",
    transform: "translate(0 271.999)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g360",
    transform: "translate(565.155 336.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g372",
    opacity: 0.2,
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M-2.516-36.065,14.8-57.333,7.871-19.248,2.43.042,14.8-20.731,6.387,3.5l9.4,2.473L23.2,20.322,13.312,22.3,10.344,9.935,2.43,4.494l7.914,12.86L12.817,31.7,2.43,47.526-4,33.182,2.43,17.849-.538,1.526Z",
    transform: "translate(4 57.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g376",
    transform: "translate(546.359 331.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g388",
    opacity: 0.4,
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g386",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "M0,0,9.4,9.892l-.989,18.8L5.935,35.612Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g392",
    transform: "translate(546.359 396.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g404",
    opacity: 0.2,
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g402",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M0-33.549.495-22.667l8.9-8.9v8.9L7.419-17.721l4.946,9.4v-9.892c0-.989,3.957-5.935,3.957-5.935V-53.333L11.871-40.968Z",
    transform: "translate(0 53.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g408",
    transform: "translate(598.789 349.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g420",
    opacity: 0.4,
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g418",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M0-5.871S5.935-3.4,5.935-4.387,12.86-9.333,12.86-9.333L18.3,8.473l6.925,17.312L9.892,30.731,4.452,34.193,6.43,17.376,2.473-.43Z",
    transform: "translate(0 9.333)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g424",
    transform: "translate(449.911 220.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M-93.35-23.076l8.094,6.538a.919.919,0,0,1,.256.324l4.336,9.154a.912.912,0,0,0,.056.1L-77.263-1.7a.926.926,0,0,1,.122.289l2.917,12.641a.979.979,0,0,0,.038.125l1.031,2.681a14.5,14.5,0,0,1,.769,7.586L-73.116,26a.927.927,0,0,0,.448.954l10.54,6.149a.927.927,0,0,1,.347,1.245l-2.443,4.48a.926.926,0,0,1-.245.288l-3.47,2.7a.928.928,0,0,0-.087,1.388l.83.83a.927.927,0,0,1,.224.949l-.631,1.894a.927.927,0,0,1-.728.621.928.928,0,0,0-.339,1.7l1.54.963a.928.928,0,0,1,.417.6l.39,1.949a.939.939,0,0,1,.014.266l-.459,5.045a.923.923,0,0,0,.094.5l1.814,3.63a.905.905,0,0,1,.071.19l1.369,5.475a.929.929,0,0,1-.094.686L-65.1,71.277a.929.929,0,0,0-.075.754l1.766,5.3a.924.924,0,0,1,.026.495l-1.878,8.451a.935.935,0,0,0,0,.4l.945,4.251.965,5.31a.937.937,0,0,0,.083.249L-61.511,100a.929.929,0,0,1,.062.67l-.844,2.954a.92.92,0,0,0-.033.328l.962,12.019a.932.932,0,0,1-.039.35l-2.278,7.289a.929.929,0,0,0,.143.833l1.138,1.517a.934.934,0,0,0,.139.148l6.781,5.812a.962.962,0,0,1,.121.125l3.022,3.776a.263.263,0,0,0,.461-.226l-2.031-8.472a.266.266,0,0,1,.02-.179l3.409-6.818a.359.359,0,0,0,.017-.044l2.453-8.339a.262.262,0,0,0,.009-.1l-.489-5.865a.3.3,0,0,0-.006-.042l-1.97-7.876a.253.253,0,0,1-.006-.035L-51.951,84.5s0-.009,0-.014l-1.969-11.815a.259.259,0,0,1,0-.1l1.961-9.312a.244.244,0,0,1,.025-.07L-48,55.823a.265.265,0,0,1,.016-.027l3.341-4.772a.263.263,0,0,1,.3-.1l4.148,1.383a.264.264,0,0,0,.223-.027l3.832-2.395a.305.305,0,0,1,.042-.021l4.917-1.967.014-.005,3.52-1.173a.263.263,0,0,0-.029-.507L-38.6,43.939l-9.786-2.446a.263.263,0,0,1-.163-.122l-4.881-8.3a.2.2,0,0,1-.016-.032L-55.878,27.2a.268.268,0,0,1-.015-.152l.948-4.74a.261.261,0,0,0-.06-.225l-6.766-7.733a.261.261,0,0,0-.184-.09l-9.111-.48A.264.264,0,0,1-71.3,13.6L-74.21,5.359l-2.464-7.884a.267.267,0,0,0-.026-.057l-2.945-4.908a.2.2,0,0,1-.012-.023l-4.431-9.353a.247.247,0,0,0-.04-.061l-6.881-7.864a.266.266,0,0,0-.045-.04L-103.375-33.7a.189.189,0,0,0-.036-.022l-5.86-2.931a.266.266,0,0,0-.118-.028h-9.768a.26.26,0,0,0-.117.028l-3.9,1.949a20.861,20.861,0,0,0-6.773,5.4l-4.1,4.978a.281.281,0,0,0-.021.029l-6.41,10.355a.267.267,0,0,0-.018.036l-5.427,12.827a.309.309,0,0,0-.01.03L-147.9,5.825a.281.281,0,0,0-.01.057l-.492,8.372c0,.005,0,.01,0,.015v6.39a.252.252,0,0,0,.008.064l1.971,7.883,2.473,8.9,2.465,9.861a.274.274,0,0,1,.008.064v3.784a.263.263,0,0,0,.117.219l2.725,1.817a.262.262,0,0,1,.117.234L-139,61.722a.3.3,0,0,0,0,.046l.978,8.309a.26.26,0,0,0,.057.136l4.355,5.323a.265.265,0,0,1,.057.134l1.471,11.77a.223.223,0,0,1,0,.051l-.473,6.617a.263.263,0,0,0,.263.282h4.584a.263.263,0,0,1,.146.044l5.8,3.868a.262.262,0,0,0,.146.045h1.142a.263.263,0,0,0,.263-.263V95.424a.271.271,0,0,0-.015-.089l-2.447-6.852a.258.258,0,0,1-.014-.061l-.986-9.366-.976-6.345a.261.261,0,0,0-.074-.146l-6.285-6.285a.263.263,0,0,1-.077-.2l.487-7.8.493-6.4a.256.256,0,0,1,.009-.052l.962-3.364a.266.266,0,0,0,0-.146l-3.437-11.783a.226.226,0,0,1-.007-.03l-1.481-8.888-1.977-11.368a.179.179,0,0,1,0-.018L-137.519,1.91a.24.24,0,0,1,0-.027V-6a.237.237,0,0,1,0-.033l.981-7.846a.257.257,0,0,1,.032-.1l3.917-6.855a.28.28,0,0,1,.032-.045l3.934-4.425.011-.011,4.428-4.428a.231.231,0,0,1,.04-.033l4.363-2.909a.266.266,0,0,1,.146-.044h7.812a.237.237,0,0,1,.046,0l8.318,1.468a.267.267,0,0,1,.12.055Z",
    transform: "translate(148.402 36.684)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g428",
    transform: "translate(344.557 334.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    d: "M0-185.355,20.774-291.7l2.473-2.968,5.935,2.968-4.452,34.623L13.355-205.14,10.387-180.9Z",
    transform: "translate(0 294.666)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g432",
    transform: "translate(343.073 331.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path434",
    d: "M-84.71-15.936l-26.215-9.4-3.462,1.484-6.43,39.569-6.43,39.075-7.419,34.129,2.968.989-1.484-3.462,7.419-31.656,6.43-38.58,6.43-37.1,2.473-2.473,6.43,3.462-1.978,15.333L-111.914,27.1-122.3,74.579l-1.978,12.86,41.053-16.322-.989-19.785,2.473-18.3,1.484-1.978L-87.183,9.785l.989-17.312Z",
    transform: "translate(134.666 25.333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g436",
    transform: "translate(343.563 381.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path438",
    d: "M-218.667,0l-30.222,25.834a7.5,7.5,0,0,1-.942.688l-32.743,20.224a5.62,5.62,0,0,1-.821.418l-6.54,2.694a3.843,3.843,0,0,1-2.888.014l-3.212-1.285a1.848,1.848,0,0,1-.521-.318l-6.965-6.036a3.386,3.386,0,0,0-.47-.341l-2.223-1.333h-2.653a3.041,3.041,0,0,0-1.512.4l-2.76,1.577h-1.526a4.323,4.323,0,0,0-2.6.865l-.825.619-1.484.989-2.107-.3a1.569,1.569,0,0,0-1.732,1.122l-.394,1.378a1.9,1.9,0,0,0,.177,1.462l1.013,1.774a2.812,2.812,0,0,0,1.67,1.31l1.783.509a4.273,4.273,0,0,0,1.178.165h2.862l-3.957,1.978-10.387,4.452-6.43,2.968-8.964,4.034a3.544,3.544,0,0,0-1.493,1.265l-.587.88a4.092,4.092,0,0,0-.662,2.722l.172,1.545a3.462,3.462,0,0,0,1.278,2.321l.043.034a3.658,3.658,0,0,0,2.961.739l6.264-1.174,5.441-1.484.495.989-5.441,2.473a4.079,4.079,0,0,0-1.139,3.554l.239,1.438a3.754,3.754,0,0,0,2.793,3.025l1.569.392,4.452-1.484h1.484l-1.484,2.473-.094.284a6.009,6.009,0,0,0,.6,5.083l.214.341a2.589,2.589,0,0,0,2.2,1.217h3.017l2.968-1.978h1.484L-318.58,92l-.828.827a2.469,2.469,0,0,0-.547,2.662,2.5,2.5,0,0,0,1.337,1.37l1.321.566a4.014,4.014,0,0,0,2.453.229l3.188-.708,13.849-6.43,6.925-2.968,6.43-5.441,4.043-3.234a7.257,7.257,0,0,1,1.986-1.129l1.159-.435a27.017,27.017,0,0,0,3.327-1.512l4.818-2.594,14.839-6.43L-234,59.354l17.316-6.38a28.549,28.549,0,0,0,2.89-1.25l15.287-7.643a24.064,24.064,0,0,0,2.156-1.22l8.744-5.565a16.947,16.947,0,0,1,2.275-1.215l10.475-4.609a11.912,11.912,0,0,1,1.447-.529l6.117-1.8a3.238,3.238,0,0,0,2.118-1.97,10.471,10.471,0,0,0,.579-5.03l-.135-1.034a81.168,81.168,0,0,0-3.485-15.174l-8.9,3.462-9.892,1.484L-197.4,8.9l-9.892-2.473-6.925-2.473Z",
    transform: "translate(347.623)",
    fill: "#eab5a8"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.1d04af535519969436ed97c27a3c8889.svg";
export { ForwardRef as ReactComponent };